import React from "react";
import { ProductFormValues } from "../../components/ProductForm/types";

export const ScreenContext = React.createContext<{
  onSubmit: (tags: string[]) => void;
  originalFormValues: ProductFormValues;
}>({
  onSubmit: () => {},
  originalFormValues: {} as ProductFormValues,
});
